// 全局业务常量
// 与后端 Constants.java 对齐，改动容量时前后端需同步修改

// 背包默认容量（对应后端 Constants.CABINET_VOLUME）
export const POCKET_VOLUME = 30;

// 家中最多可摆放的柜子数量（对应后端 Constants.CABINET_MAX_COUNT）
export const CABINET_MAX_COUNT = 30;

// 街道地面可放置的道具格位数（对应后端 RedisUtil/ItemPickDropHandler 的默认数组大小）
export const GROUND_ITEM_LIMIT = 30;
